import React from "react"
import { Fixed, Close, Drawer, Flex } from "rebass"
import { responsiveStyle } from "styled-system"

import colors from "../../config/colors.js"

const AppDrawer = ({ open, handleClose, children, ...rest }) => (
  <Drawer open={open} {...rest}>
    <Flex
      flexDirection="column"
      onClick={() => {
        handleClose()
      }}
      pt={4}
    >
      <Fixed p={3} right={0} top={0}>
        <Close fontSize={5} />
      </Fixed>
      {children}
    </Flex>
  </Drawer>
)

export default AppDrawer



// WEBPACK FOOTER //
// ./src/components/AppDrawer/index.js